/**
 * 菜单配置
 * label 为 i18n key（locales/*.json 的 menu.*），由 layout.tsx 渲染时 t() 翻译；
 * 与 routes.tsx 的 appRoutes.name 共用同一批 key，避免两处重复维护中文。
 */

export interface MenuItem {
  key: string;
  label: string;
  icon?: string;
  path?: string;
  permission?: string;
  children?: MenuItem[];
}

export const menuItems: MenuItem[] = [
  { key: 'dashboard', label: 'menu.dashboard', icon: 'IconDashboard', path: '/dashboard', permission: 'dashboard:view' },
  { key: 'inquiries', label: 'menu.inquiries', icon: 'IconMessage', path: '/inquiries', permission: 'inquiries:view' },
  { key: 'downloads', label: 'menu.downloads', icon: 'IconDownload', path: '/downloads', permission: 'downloads:view' },
  { key: 'newsletters', label: 'menu.newsletters', icon: 'IconEmail', path: '/newsletters', permission: 'newsletters:view' },
  { key: 'users', label: 'menu.users', icon: 'IconUserGroup', path: '/users', permission: 'users:view' },
  { key: 'roles', label: 'menu.roles', icon: 'IconSafe', path: '/roles', permission: 'roles:view' },
  { key: 'news', label: 'menu.news', icon: 'IconFile', path: '/news', permission: 'news:view' },
  { key: 'masterDataBd', label: 'menu.bdOwners', icon: 'IconUserAdd', path: '/master-data/bd', permission: 'bd-owners:view' },
  { key: 'operationLogs', label: 'menu.operationLogs', icon: 'IconFile', path: '/operation-logs', permission: 'logs:view' },
];
